import { DIAS } from "./turnos";

type FarmaciaTexto = { nombre: string; direccion: string; telefono: string };

/** Texto del posteo de Facebook del día. `fecha` es YYYY-MM-DD. El turno cambia siempre a las 8:30. */
export function textoFacebook(fecha: string, farmacias: FarmaciaTexto[]): string {
  const [y, m, d] = fecha.split("-").map(Number);
  const hoy = new Date(y, m - 1, d);
  const manana = new Date(y, m - 1, d + 1);
  const dia = DIAS[hoy.getDay()];
  const diaSiguiente = DIAS[manana.getDay()];

  const lineas = farmacias.map((f) => {
    const tel = f.telefono.trim();
    const partes = [f.nombre, f.direccion, tel === "No disponible" ? "" : tel]
      .map((s) => s.trim())
      .filter((s) => s !== "");
    return "\u{1F48A}" + partes.join(" - ");
  });

  return [
    `Farmacia de Turno \u{1F4C5} ${dia} ${d}: desde las 8:30 am, hasta el ${diaSiguiente} a las 8:30 am`,
    lineas.join("\n"),
    "\u{1F55B} Importante: el turno rige hasta las 8:30 am del día siguiente, incluso pasada la medianoche.",
    "Agendá el contacto de Whatsapp y tené las farmacias de turno en tu celular! 2494623305\n" +
      "\u{1F49A} Tu médico prescribe. Pero la Farmacia la elegís vos!",
    "#farmaciasdeturnotandil #colfarmatandil #farmacias #tandil #farmaciasdeturno",
  ].join("\n\n");
}
